export default "__VITE_ASSET__BBbSH9lG__"